var map = {
	"./airtel-logo.svg": 756,
	"./icons-usage-1.svg": 757,
	"./icons-usage-2.svg": 758,
	"./light-bulb.svg": 759
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 755;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs ^\.\/.*\.svg$
// module id = 755
// module chunks = 0